"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Banda App API
 * The API for the Banda App
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EquipmentControllerApi = exports.EquipmentControllerApiFactory = exports.EquipmentControllerApiFp = exports.EquipmentControllerApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * EquipmentControllerApi - axios parameter creator
 * @export
 */
const EquipmentControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} qrCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentBulkUnassignPost: (qrCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'qrCode' is not null or undefined
            (0, common_1.assertParamExists)('apiEquipmentBulkUnassignPost', 'qrCode', qrCode);
            const localVarPath = `/api/equipment/bulkUnassign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (qrCode !== undefined) {
                localVarQueryParameter['QrCode'] = qrCode;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {number} [isAssignedToUser]
         * @param {boolean} [assignedOnly]
         * @param {string} [assignedUserSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentGet: (searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, isAssignedToUser, assignedOnly, assignedUserSearch, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/equipment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }
            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (isAssignedToUser !== undefined) {
                localVarQueryParameter['isAssignedToUser'] = isAssignedToUser;
            }
            if (assignedOnly !== undefined) {
                localVarQueryParameter['assignedOnly'] = assignedOnly;
            }
            if (assignedUserSearch !== undefined) {
                localVarQueryParameter['assignedUserSearch'] = assignedUserSearch;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEquipmentIdDelete', 'id', id);
            const localVarPath = `/api/equipment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEquipmentIdGet', 'id', id);
            const localVarPath = `/api/equipment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {Equipment} equipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentIdPut: (id, equipment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEquipmentIdPut', 'id', id);
            // verify required parameter 'equipment' is not null or undefined
            (0, common_1.assertParamExists)('apiEquipmentIdPut', 'equipment', equipment);
            const localVarPath = `/api/equipment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(equipment, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Equipment} equipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentPost: (equipment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'equipment' is not null or undefined
            (0, common_1.assertParamExists)('apiEquipmentPost', 'equipment', equipment);
            const localVarPath = `/api/equipment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(equipment, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} qrCodes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentPrintQrCodesGet: (qrCodes, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'qrCodes' is not null or undefined
            (0, common_1.assertParamExists)('apiEquipmentPrintQrCodesGet', 'qrCodes', qrCodes);
            const localVarPath = `/api/equipment/printQrCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (qrCodes !== undefined) {
                localVarQueryParameter['qrCodes'] = qrCodes;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EquipmentControllerApiAxiosParamCreator = EquipmentControllerApiAxiosParamCreator;
/**
 * EquipmentControllerApi - functional programming interface
 * @export
 */
const EquipmentControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EquipmentControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} qrCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentBulkUnassignPost(qrCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEquipmentBulkUnassignPost(qrCode, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {number} [isAssignedToUser]
         * @param {boolean} [assignedOnly]
         * @param {string} [assignedUserSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, isAssignedToUser, assignedOnly, assignedUserSearch, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEquipmentGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, isAssignedToUser, assignedOnly, assignedUserSearch, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEquipmentIdDelete(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEquipmentIdGet(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {Equipment} equipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentIdPut(id, equipment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEquipmentIdPut(id, equipment, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Equipment} equipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentPost(equipment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEquipmentPost(equipment, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} qrCodes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentPrintQrCodesGet(qrCodes, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEquipmentPrintQrCodesGet(qrCodes, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.EquipmentControllerApiFp = EquipmentControllerApiFp;
/**
 * EquipmentControllerApi - factory interface
 * @export
 */
const EquipmentControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EquipmentControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} qrCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentBulkUnassignPost(qrCode, options) {
            return localVarFp.apiEquipmentBulkUnassignPost(qrCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {number} [isAssignedToUser]
         * @param {boolean} [assignedOnly]
         * @param {string} [assignedUserSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, isAssignedToUser, assignedOnly, assignedUserSearch, options) {
            return localVarFp.apiEquipmentGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, isAssignedToUser, assignedOnly, assignedUserSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentIdDelete(id, options) {
            return localVarFp.apiEquipmentIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentIdGet(id, options) {
            return localVarFp.apiEquipmentIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {Equipment} equipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentIdPut(id, equipment, options) {
            return localVarFp.apiEquipmentIdPut(id, equipment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Equipment} equipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentPost(equipment, options) {
            return localVarFp.apiEquipmentPost(equipment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} qrCodes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEquipmentPrintQrCodesGet(qrCodes, options) {
            return localVarFp.apiEquipmentPrintQrCodesGet(qrCodes, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EquipmentControllerApiFactory = EquipmentControllerApiFactory;
/**
 * EquipmentControllerApi - object-oriented interface
 * @export
 * @class EquipmentControllerApi
 * @extends {BaseAPI}
 */
class EquipmentControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} qrCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentControllerApi
     */
    apiEquipmentBulkUnassignPost(qrCode, options) {
        return (0, exports.EquipmentControllerApiFp)(this.configuration).apiEquipmentBulkUnassignPost(qrCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [searchField]
     * @param {string} [searchString]
     * @param {number} [pageSize]
     * @param {number} [pageNumber]
     * @param {string} [sortBy]
     * @param {string} [sortOrder]
     * @param {number} [isAssignedToUser]
     * @param {boolean} [assignedOnly]
     * @param {string} [assignedUserSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentControllerApi
     */
    apiEquipmentGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, isAssignedToUser, assignedOnly, assignedUserSearch, options) {
        return (0, exports.EquipmentControllerApiFp)(this.configuration).apiEquipmentGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, isAssignedToUser, assignedOnly, assignedUserSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentControllerApi
     */
    apiEquipmentIdDelete(id, options) {
        return (0, exports.EquipmentControllerApiFp)(this.configuration).apiEquipmentIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentControllerApi
     */
    apiEquipmentIdGet(id, options) {
        return (0, exports.EquipmentControllerApiFp)(this.configuration).apiEquipmentIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {Equipment} equipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentControllerApi
     */
    apiEquipmentIdPut(id, equipment, options) {
        return (0, exports.EquipmentControllerApiFp)(this.configuration).apiEquipmentIdPut(id, equipment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Equipment} equipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentControllerApi
     */
    apiEquipmentPost(equipment, options) {
        return (0, exports.EquipmentControllerApiFp)(this.configuration).apiEquipmentPost(equipment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} qrCodes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentControllerApi
     */
    apiEquipmentPrintQrCodesGet(qrCodes, options) {
        return (0, exports.EquipmentControllerApiFp)(this.configuration).apiEquipmentPrintQrCodesGet(qrCodes, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EquipmentControllerApi = EquipmentControllerApi;
